import { render, staticRenderFns } from "./PortraitVideoControllerParts.vue?vue&type=template&id=43435b16&scoped=true"
import script from "./PortraitVideoControllerParts.vue?vue&type=script&lang=ts"
export * from "./PortraitVideoControllerParts.vue?vue&type=script&lang=ts"
import style0 from "./PortraitVideoControllerParts.vue?vue&type=style&index=0&id=43435b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43435b16",
  null
  
)

export default component.exports